export default __webpack_public_path__ + "static/media/error.a941fcaf.svg";